"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'myStuff';
exports.FETCH_MY_LIST = exports.namespace + "/FETCH_MY_LIST";
exports.SET_DEVICE_VIDEO_QUALITY = exports.namespace + "/SET_DEVICE_VIDEO_QUALITY";
//# sourceMappingURL=constants.js.map